import type { CSSProperties } from "react"

export const DEFAULT_LABEL_COLOR = "#0969da"

export const LABEL_COLOR_PALETTE = [
  "#b60205",
  "#d93f0b",
  "#fbca04",
  "#0e8a16",
  "#006b75",
  "#1d76db",
  "#0052cc",
  "#5319e7",
  "#e99695",
  "#f9d0c4",
  "#fef2c0",
  "#c2e0c6",
  "#bfdadc",
  "#c5def5",
  "#bfd4f2",
  "#d4c5f9",
]

export const normalizeLabelColor = (color: string) => {
  const normalized = color.trim().toLowerCase()
  return /^#[0-9a-f]{6}$/.test(normalized) ? normalized : null
}

const getRelativeLuminance = (hex: string) => {
  const normalized = normalizeLabelColor(hex) ?? DEFAULT_LABEL_COLOR
  const channels = [1, 3, 5].map((start) => {
    const channel = parseInt(normalized.slice(start, start + 2), 16) / 255
    return channel <= 0.03928
      ? channel / 12.92
      : Math.pow((channel + 0.055) / 1.055, 2.4)
  })
  return channels[0] * 0.2126 + channels[1] * 0.7152 + channels[2] * 0.0722
}

export const getReadableLabelTextColor = (backgroundColor: string) => {
  const luminance = getRelativeLuminance(backgroundColor)
  const blackContrast = (luminance + 0.05) / 0.05
  const whiteContrast = 1.05 / (luminance + 0.05)
  return blackContrast >= whiteContrast ? "#000000" : "#ffffff"
}

export const getRandomLabelColor = () =>
  LABEL_COLOR_PALETTE[Math.floor(Math.random() * LABEL_COLOR_PALETTE.length)]

export const getLabelChipStyle = (color?: string): CSSProperties => {
  const backgroundColor =
    normalizeLabelColor(color ?? "") ?? DEFAULT_LABEL_COLOR
  return {
    backgroundColor,
    borderColor: backgroundColor,
    color: getReadableLabelTextColor(backgroundColor),
  }
}
